import React from 'react';

interface ManufacturerLegalFieldsProps {
  legalName: string;
  address: string;
  directors: string;
  taxNumber: string;
  vatId: string;
  onLegalName: (value: string) => void;
  onAddress: (value: string) => void;
  onDirectors: (value: string) => void;
  onTaxNumber: (value: string) => void;
  onVatId: (value: string) => void;
}

const inputClass =
  'mt-1 w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500';

export const ManufacturerLegalFields: React.FC<ManufacturerLegalFieldsProps> = ({
  legalName,
  address,
  directors,
  taxNumber,
  vatId,
  onLegalName,
  onAddress,
  onDirectors,
  onTaxNumber,
  onVatId,
}) => (
  <>
    <div className="sm:col-span-2">
      <label className="text-xs font-bold text-gray-500 uppercase tracking-wide">
        Legal company name
      </label>
      <input
        type="text"
        value={legalName}
        onChange={(e) => onLegalName(e.target.value)}
        placeholder="Producer on supermarket delivery notes"
        className={inputClass}
      />
    </div>
    <div className="sm:col-span-2">
      <label className="text-xs font-bold text-gray-500 uppercase tracking-wide">
        Registered address
      </label>
      <input type="text" value={address} onChange={(e) => onAddress(e.target.value)} className={inputClass} />
    </div>
    <div>
      <label className="text-xs font-bold text-gray-500 uppercase tracking-wide">
        Managing directors
      </label>
      <input type="text" value={directors} onChange={(e) => onDirectors(e.target.value)} className={inputClass} />
    </div>
    <div>
      <label className="text-xs font-bold text-gray-500 uppercase tracking-wide">Tax number</label>
      <input type="text" value={taxNumber} onChange={(e) => onTaxNumber(e.target.value)} className={inputClass} />
    </div>
    <div>
      <label className="text-xs font-bold text-gray-500 uppercase tracking-wide">VAT ID</label>
      <input
        type="text"
        value={vatId}
        onChange={(e) => onVatId(e.target.value)}
        placeholder="Used when tax number is empty"
        className={inputClass}
      />
    </div>
  </>
);
